import {LucideIcon} from '@ui/icons/lucide/lucide-icon-wrapper';
import {SvgIconProps} from '@ui/icons/svg-icon';
import {
  HeadsetIcon,
  LifeBuoyIcon,
  SettingsIcon,
  UserPenIcon,
} from 'lucide-react';
import {ReactElement} from 'react';

export const authDropdownIcons: Record<string, ReactElement<SvgIconProps>> = {
  '/admin/settings': <LucideIcon icon={SettingsIcon} />,
  '/dashboard/conversations': <LucideIcon icon={HeadsetIcon} />,
  '/account-settings': <LucideIcon icon={UserPenIcon} />,
  '/hc/tickets': <LucideIcon icon={LifeBuoyIcon} />,
};
